module.exports = __webpack_public_path__ + "img/voluntary-certification.d8997c05.png";